import { trpc } from '@/shared/api/trpc';

// The current reporter's own incidents (drawer list). Server forces the
// reporter scope + returns the reduced own-projection (no financial fields).
// `enabled` lets the drawer defer the fetch until it is opened.
export const useMyIncidents = (enabled = true) =>
  trpc.incidents.myList.useQuery(
    {
      page: 0,
      pageSize: 50,
      sortBy: 'createdOn',
      sortOrder: 'desc',
    },
    { enabled }
  );
